const subject = {
  createSubject: async function(subjectToCreate) {
    const query = `
      mutation($title: String!, $description: String!, $organizationId: Int! ) {
        CreateSubject(title: $title, description: $description, organizationId: $organizationId) {
          Subject_Id
        }
      }`;
    const variables = {
      title: subjectToCreate.Title,
      description: subjectToCreate.Description,
      organizationId: parseInt(subjectToCreate.Organization_Id)
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      subjectToCreate.Subject_Id = res.data.CreateSubject.Subject_Id;
      return subjectToCreate;
    });
  },

  updateSubject: async function(subjectToUpdate) {
    const query = `
      mutation($subjectId: Int!, $title: String!, $description: String!, $organizationId: Int! ) {
        UpdateSubject(subjectId: $subjectId, title: $title, description: $description, organizationId: $organizationId) {
          Subject_Id
        }
      }`;
    const variables = {
      subjectId: parseInt(subjectToUpdate.Subject_Id),
      title: subjectToUpdate.Title,
      description: subjectToUpdate.Description,
      organizationId: parseInt(subjectToUpdate.Organization_Id)
    };
    return this.$store.getters.fetcher({ query, variables }).then(() => {
      return subjectToUpdate;
    });
  },

  getMySubjects: async function() {
    const query =
      `
      {
        GetMySubjects(userId: ` +
      parseInt(this.$store.getters.user.User_Id) +
      `)
        {
          Subject_Id
          Title
          Description
          Organization_Id
          Units{
            Unit_Id
            Title
            Description
            Score_Template_Id
            Num_Scores
          }
        }
      }`;
    return this.$store.getters
      .fetcher({ query })
      .then(res => res.data.GetMySubjects);
  },

  getMyStarredSubjects: async function() {
    const query =
      `
      {
        GetMyStarredSubjects(userId: ` +
      parseInt(this.$store.getters.user.User_Id) +
      `)
        {
          Subject_Id
          Title
          Description
          Organization_Id
          Units{
            Unit_Id
            Title
            Description
            Score_Template_Id
            Num_Scores
          }
        }
      }`;
    return this.$store.getters
      .fetcher({ query })
      .then(res => res.data.GetMyStarredSubjects);
  },

  getPermissionSubjects: async function() {
    const query =
      `
      {
        GetPermissionSubjects(userId: ` +
      parseInt(this.$store.getters.user.User_Id) +
      `)
        {
          Subject_Id
          Title
          Description
          Organization_Id
        }
      }`;
    return this.$store.getters
      .fetcher({ query })
      .then(res => res.data.GetPermissionSubjects);
  },

  createStudentSubjects: async function(studentId, subjectIds) {
    const query = `
      mutation($studentId: Int!, $subjectIds: [Int]!) {
        CreateStudentSubjects(studentId: $studentId, subjectIds: $subjectIds) {
          Student_Subject_Id
          Student_Id
          Subject_Id
        }
      }`;
    const variables = {
      studentId: parseInt(studentId),
      subjectIds: subjectIds.map(s => parseInt(s))
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      return res.data.CreateStudentSubjects;
    });
  },

  createStudentSubjectsPairs: async function(studentSubjectPairs) {
    const query = `
      mutation($studentSubjectsPairs: [StudentSubjectsPair]!) {
        CreateStudentSubjectsPairs(studentSubjectsPairs: $studentSubjectsPairs)
      }`;
    var parsedStudentSubjectPairs = [];
    studentSubjectPairs.forEach(sspair => {
      parsedStudentSubjectPairs.push({
        studentId: parseInt(sspair.studentId),
        subjectIds: sspair.subjectIds.map(sid => parseInt(sid))
      });
    });
    const variables = {
      studentSubjectsPairs: parsedStudentSubjectPairs
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      return res.data.CreateStudentSubjectsPairs;
    });
  },

  archiveStudentSubjectsPairs: async function(studentSubjectsPairs) {
    const query = `
      mutation($studentSubjectsPairs: [StudentSubjectsPair]!) {
        ArchiveStudentSubjectsPairs(studentSubjectsPairs: $studentSubjectsPairs)
      }`;
    var parsedStudentSubjectPairs = [];
    studentSubjectsPairs.forEach(sspair => {
      parsedStudentSubjectPairs.push({
        studentId: parseInt(sspair.studentId),
        subjectIds: sspair.subjectIds.map(sid => parseInt(sid))
      });
    });
    const variables = {
      studentSubjectsPairs: parsedStudentSubjectPairs
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      return res.data.ArchiveStudentSubjectsPairs;
    });
  },

  createStarSubject: async function(subjectId) {
    const query = `
      mutation($userId: Int!, $subjectId: Int!) {
        CreateUserStarSubject(userId: $userId, subjectId: $subjectId){
          Subject_Id
        }
      }`;
    const variables = {
      userId: parseInt(this.$store.getters.user.User_Id),
      subjectId: parseInt(subjectId)
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      this.$store.getters.user.Starred_Subjects.push(
        res.data.CreateUserStarSubject
      );
    });
  },

  removeStarSubject: async function(subjectId) {
    const query = `
      mutation($userId: Int!, $subjectId: Int!) {
        RemoveUserStarSubject(userId: $userId, subjectId: $subjectId)
      }`;
    const variables = {
      userId: parseInt(this.$store.getters.user.User_Id),
      subjectId: parseInt(subjectId)
    };
    return this.$store.getters.fetcher({ query, variables }).then(() => {
      this.$store.getters.user.Starred_Subjects = this.$store.getters.user.Starred_Subjects.filter(
        s => s.Subject_Id != subjectId
      );
    });
  },

  archiveSubject: async function(subjectId) {
    const query = `
      mutation($subjectId: Int!) {
        ArchiveSubject(subjectId: $subjectId)
      }`;
    const variables = {
      subjectId: parseInt(subjectId)
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      res.data.ArchiveSubject;
    });
  },

  unarchiveSubject: async function(subjectId) {
    const query = `
      mutation($subjectId: Int!) {
        UnarchiveSubject(subjectId: $subjectId)
      }`;
    const variables = {
      subjectId: parseInt(subjectId)
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      res.data.UnarchiveSubject;
    });
  },

  deleteSubject: async function(subjectId) {
    const query = `
      mutation($subjectId: Int!) {
        DELETESUBJECT(subjectId: $subjectId)
      }`;
    const variables = {
      subjectId: parseInt(subjectId)
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      res.data.DELETESUBJECT;
    });
  }
};

export { subject };
